import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';

/** True when every word of the search appears in one of the staff fields (name, Staff ID, eSSL code). */
export const matchStaff = (q, ...fields) => {
  const words = String(q || '').toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return true;
  const hay = fields.map((f) => String(f ?? '').toLowerCase()).join(' ');
  return words.every((w) => hay.includes(w));
};

/** Hub-wide employee search box — the value is kept while switching tabs. */
export const StaffSearchBar = ({ value, onChange }) => (
  <div className="relative w-full sm:w-[380px]" data-testid="hub-staff-search">
    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
    <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder="Search employee — name, Staff ID or eSSL code"
      className="pl-9 pr-9 bg-white" data-testid="hub-staff-search-input" />
    {value && (
      <button type="button" onClick={() => onChange('')} aria-label="Clear search" data-testid="hub-staff-search-clear"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-gray-400 hover:text-gray-700 transition-colors">
        <X className="w-4 h-4" />
      </button>
    )}
  </div>
);

/** "Showing N of M" line under a tab while a search is active. */
export const SearchNote = ({ q, shown, total, testId }) => (q?.trim() ? (
  <p className={`text-xs ${shown ? 'text-gray-500' : 'text-amber-700'}`} data-testid={testId}>
    {shown ? `Showing ${shown} of ${total} for “${q.trim()}”` : `No employee matches “${q.trim()}” here`}
  </p>
) : null);

export default StaffSearchBar;
